import React from "react";

import {
  Combobox as SharedCombobox,
  ComboboxProps as SharedComboboxProps,
} from "@sportal/cdk/combobox";
import { useIntlTranslate } from "../../hooks";
import { Modify } from "@sportal/lib/types.helpers";

import "./Combobox.scss";

interface ComboboxProps
  extends Modify<
    SharedComboboxProps,
    {
      comboboxSearchWrapperAriaLabel?: string;
      toggleButtonAriaLabel?: string;
    }
  > {}

export const Combobox = (props: ComboboxProps) => {
  const translate = useIntlTranslate();

  return (
    <SharedCombobox
      searchInputPlaceholder={translate("search")}
      comboboxSearchWrapperAriaLabel={translate("aria_combobox_label")}
      toggleButtonAriaLabel={translate("aria_combobox_toggle")}
      noResultsMessage={translate("no_results_found")}
      {...props}
    />
  );
};
